import React, {useEffect} from "react";
import PromoBudget from "./PromoBudget";
import PromoPositions from "./PromoPositions";
import PromoDuration from "./PromoDuration";
import PromoPromouter from "./PromoPromouter";
import PromoPaticipants from "./PromoPaticipants";
import PromoBlockchain from "./PromoBlockchain";
import {useSelector} from "react-redux";

export default function PromoCreate({create}) {
    const promoType = useSelector((state) => state.promoForm.promoType)

    return (
        <>
            {promoType === 'crystalsAndCrypto' || promoType === 'cryptoOnly' ?
            <div className={'w-full flex flex-col gap-2'}>
                <PromoBudget/>
                <PromoBlockchain/>
                <PromoPositions/>
                <PromoPaticipants create={create} />
                <PromoDuration/>
                <PromoPromouter/>
            </div>:''
            }
        </>
    )
}
